/* eslint-disable indent */
const initialState = {
	"paso": 0,
	"ramo": "",
	"poliza": "",
	"inicioVigenciaPoliza": "",
	"inicioVigenciaPolizaDate": "",
	"certificado": "",
	"motor": "",
	"placas": "",
	"email": "",
	"fechaNacimiento": "",
	"fechaNacimientoDate": "",
	"ladaFijo": "",
	"telFijo": "",
	"ladaCelular": "",
	"telCelular": "",
	"apaterno": "",
	"amaterno": "",
	"nombres": "",
	"rfc": "",
	"respuesta": "",
	"password": "",
	"pregunta1": "",
	"pregunta2": "",
	"respuesta1": "",
	"respuesta2": "",
	"tipo": "",
	"extension": "",
	"lada": "",
	"telefono": "",
	"hashOne": "",
	"hashTwo": "",
	"completo": false,
	"rfcbnmx": "",
	"polizaBanamex": false,
	"fechaDeNacimiento": "",
	"fechaDeNacimientoDate": "",
	"showAviso": true,
	"avisoAceptado": false,
	"mediosElectronicos": false,
	"configuracion": {
		"grupo": false,
		"motor": false,
		"certificado": false,
		"poliza_valida": false,
		"poliza_padre": false,
		"fchVigInicial": false,
		"referencia": false,
		"sistema": false
	}
};

export function registroRdc(state = initialState, action) {

	switch (action.type) {
		case "REGISTRO_PASO_SIGUIENTE":
			return {
				...state,
				"paso": state.paso + 1
			};
		case "REGISTRO_PASO_ANTERIOR":
			return {
				...state,
				"paso": state.paso - 1
			};
		case "REGISTRO_POLIZA":
			return {
				...state,
				"ramo": action.ramo,
				"poliza": action.poliza,
				"inicioVigenciaPoliza": action.inicioVigenciaPoliza,
				"inicioVigenciaPolizaDate": action.inicioVigenciaPolizaDate,
				"certificado": action.certificado,
				"motor": action.motor,
				"placas": action.placas,
				"rfcbnmx": action.rfcbnmx,
				"fechaDeNacimiento": action.fechaDeNacimiento,
				"fechaDeNacimientoDate": action.fechaDeNacimientoDate,
				"polizaBanamex": action.polizaBanamex,
				"codFiliacion": action.codFiliacion,
				"idParticipante": action.idParticipante,
				"apaterno": action.apaterno,
				"amaterno": action.amaterno,
				"nombres": action.nombres,
				"avisoAceptado": action.avisoAceptado,
				"mediosElectronicos": action.mediosElectronicos
			};
		case "REGISTRO_POLIZA_CONFIGURACION":
			return {
				...state,
				"configuracion": action.configuracion,
			};
		case "REGISTRO_POLIZA_CONFIGURACION_VALIDA":
			//console.log("*REGISTRO_POLIZA_CONFIGURACION_VALIDA");
			return {
				...state,
				"configuracion": {
					"grupo": state.configuracion.grupo,
					"motor": state.configuracion.motor,
					"certificado": state.configuracion.certificado,
					"poliza_valida": action.poliza_valida,
					"poliza_padre": state.configuracion.poliza_padre,
					"fchVigInicial": state.configuracion.fchVigInicial,
					"referencia": state.configuracion.referencia,
					"sistema": state.configuracion.sistema
				}
			};
		case "REGISTRO_POLIZA_CONFIGURACION_VALIDA_FECHA":
			//console.log("*REGISTRO_POLIZA_CONFIGURACION_VALIDA_FECHA");
			return {
				...state,
				"configuracion": {
					"grupo": state.configuracion.grupo,
					"motor": state.configuracion.motor,
					"certificado": state.configuracion.certificado,
					"poliza_valida": action.poliza_valida,
					"poliza_padre": state.configuracion.poliza_padre,
					"fchVigInicial": action.fchVigInicial,
					"referencia": state.configuracion.referencia,
					"sistema": state.configuracion.sistema
				}
			};
		case "REGISTRO_DATOS":
			//console.log("*REGISTRO_DATOS");
			return {
				...state,
				"email": action.email,
				"fechaNacimiento": action.fechaNacimiento,
				"fechaNacimientoDate": action.fechaNacimientoDate,
				"ladaFijo": action.ladaFijo,
				"telFijo": action.telFijo,
				"ladaCelular": action.ladaCelular,
				"telCelular": action.telCelular,
				"apaterno": action.apaterno,
				"amaterno": action.amaterno,
				"nombres": action.nombres,
				"rfc": action.rfc
			};
		case "REGISTRO_SEGURIDAD":
			return {
				...state,
				"password": action.password,
				"pregunta1": action.pregunta1,
				"respuesta1": action.respuesta1,
				"pregunta2": action.pregunta2,
				"respuesta2": action.respuesta2
			};
		case "REGISTRO_PASO":
			return {
				...state,
				"paso": action.paso
			};
		case "REGISTRO_EJEMPLO_SERVICIO":
			return {
				...state,
				"respuesta": action.respuesta
			};
		case "REGISTRO_HASH":
			return {
				...state,
				"hashOne": action.hashOne,
				"hashTwo": action.hashTwo
			};
		case "REGISTRO_COMPLETO":
			return {
				...state,
				"completo": action.completo
			};
		case "AVISO_PRIVACIDAD":
			return {
				...state,
				"showAviso": action.showAviso
			};
		case "LIMPIAR_REGISTRO":
			return {
				...state,
				"paso": 0,
				"ramo": "",
				"poliza": "",
				"inicioVigenciaPoliza": "",
				"inicioVigenciaPolizaDate": "",
				"certificado": "",
				"motor": "",
				"placas": "",
				"email": "",
				"fechaNacimiento": "",
				"fechaNacimientoDate": "",
				"ladaFijo": "",
				"telFijo": "",
				"ladaCelular": "",
				"telCelular": "",
				"apaterno": "",
				"amaterno": "",
				"nombres": "",
				"rfc": "",
				"respuesta": "",
				"password": "",
				"pregunta1": "",
				"pregunta2": "",
				"respuesta1": "",
				"respuesta2": "",
				"tipo": "",
				"extension": "",
				"lada": "",
				"telefono": "",
				"hashOne": "",
				"hashTwo": "",
				"completo": false,
				"showAviso": true,
				"configuracion": {
					"grupo": false,
					"motor": false,
					"certificado": false,
					"poliza_valida": false,
					"poliza_padre": false,
					"fchVigInicial": false,
					"referencia": false,
					"sistema": false
				}
			};
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/registro/reducer.js